import React from "react"
import { ConnectDropTarget, DropTarget, DropTargetConnector } from "react-dnd"
import Column, { DraggableTypeColumn } from "./Column"
import CustomizableColumn from "./CustomizableColumn"

export interface DroppableContainerProps {
  columns: CustomizableColumn[]
  onChangeColumnsList: (columns: CustomizableColumn[]) => void
  onVisibilityChange: (name: string, visible: boolean) => void
}

interface ExtendedDroppableContainerProps extends DroppableContainerProps {
  connectDropTarget: ConnectDropTarget
}

const DroppableColumnTarget = { canDrop: () => true }

const DroppableColumnCollect = (connect: DropTargetConnector) => ({ connectDropTarget: connect.dropTarget() })

class DroppableContainer extends React.Component<ExtendedDroppableContainerProps> {
  moveColumn = (id: string, atIndex: number) => {
    const { column, index } = this.findColumn(id)
    if (column) {
      const newColumns = [...this.props.columns];
      const prevItem = newColumns.splice(atIndex, 1, column);
      newColumns.splice(index, 1, prevItem[0]);
      this.props.onChangeColumnsList(newColumns)
    }
  }

  findColumn = (id: string) => {
    const column = this.props.columns.filter((c) => c.name === id)[0]
    return {
      column,
      index: this.props.columns.indexOf(column),
    }
  }

  render() {
    const { connectDropTarget } = this.props
    return connectDropTarget(
      <div>
        {this.props.columns.filter(col => col.customize).map((column) => (
          <Column key={column.name}
            column={column}
            moveColumn={this.moveColumn}
            findColumn={this.findColumn}
            onVisibilityChange={this.props.onVisibilityChange} />))}
      </div>
    )
  }
}

export default DropTarget(DraggableTypeColumn, DroppableColumnTarget, DroppableColumnCollect)(DroppableContainer)
